<div *ngIf="isDataLoaded" class="bg-light">

    <!-- Breadcrumb -->
    <div class="store-breadcrumb">
        <div class="container">
            <a href="/">Home</a>
            <span class="sep"><svg class="icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg></span>
            <span class="current">All Stores</span>
        </div>
    </div>

    <!-- Main Content -->
    <main class="all-stores-page py-5">
        <div class="container">
            <div class="stores-layout">
                <!-- Left Sidebar -->
                <aside class="stores-sidebar">
                    <button class="sidebar-close-btn" aria-label="Close">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>

                    <div class="sidebar-about">
                        <h3 class="sidebar-title">About Stores</h3>
                        <div class="sidebar-desc-wrapper">
                            <p class="sidebar-desc" id="sidebar-desc-text" data-has-showmore="true">
                                Are you finding it hard to keep your expenses in check? No worries! We're here to assist
                                you in saving money on your purchases. At DealsZo, we offer a wide range of coupons from
                                well-known brands. Whether you're craving food or looking to update your wardrobe with
                                trendy fashion items, we have you covered. Explore discounts from popular food delivery
                                services like Uber Eats, HelloFresh, and Dinnerly, as well as fashion stores like H&M,
                                CIDER, Stacy Adams, and Princess Polly. Plus, in today's tech-savvy world, we don't want
                                you to miss out on the latest gadgets. Save on smartphones, earbuds, TVs, and more with
                                coupons from Amazon, Best Buy, DJI, Costco, and others. So, what are you waiting for?
                                Visit DealsZo because Your Savings Matters to us.
                            </p>
                        </div>
                    </div>
                </aside>
                <!-- Main Content Area -->
                <div class="stores-content-area">
                    <div class="section-header">
                        <h2>All Merchants</h2>
                    </div>
                    <!-- Filter Section -->
                    <div class="stores-filter-container mb-4">
                        <div class="alphabet-filter" id="alphabet-filter">
                            <!-- <button class="filter-btn" [class.active]="activeLetter === 'all'"
                                (click)="setActiveTab('all')">All</button> -->
                            <button class="filter-btn" *ngFor="let letter of alphabetLetters"
                                [class.active]="activeLetter === letter" (click)="setActiveTab(letter)">{{ letter
                                }}</button>
                            <button class="filter-btn" [class.active]="activeLetter === '123'"
                                (click)="setActiveTab('123')">0-9</button>
                        </div>
                    </div>
                    <!-- Stores Grid -->
                    <div class="stores-grid" id="stores-grid">
                        <ng-container *ngFor="let key of (activeLetter === 'all' ? groupedBrandKeys : [activeLetter])">
                            <ng-container *ngFor="let brand of groupedBrands[key] || []">
                                <a [href]="brand.SeoName ? '/' + brand.SeoName + '-coupons/' : '#'"
                                    class="store-item-card" [attr.data-name]="brand.StoreName">
                                    <div class="store-card-info">
                                        <h3 class="store-name">{{ brand.StoreName }}</h3>
                                        <p class="coupon-count">{{ (brand.CouponCount + brand.DealCount) }} Coupons &
                                            Offers</p>
                                    </div>
                                </a>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>